export default class CompanyProfileSearchRequest {
    states: string[] = [];
}